import { SearchPlaceResult } from '@dialogue/coredata'
import Analytics from 'APP/Services/Analytics'
import { launchMapDirection } from 'APP/Lib/MapHelpers'
import { Linking } from 'react-native'

export const handleDirections = (place: SearchPlaceResult, specialty: string) => {
  Analytics.trackEvent('button_click', {
    button_value: 'Self navigation - get directions',
    specialist: specialty,
  })

  launchMapDirection(place.name, place.full_address)
}

export const handleCall = (place: SearchPlaceResult, specialty: string) => {
  Analytics.trackEvent('button_click', {
    button_value: 'Self navigation - call',
    specialist: specialty,
  })

  Linking.openURL(`tel:${place.phone_number}`)
}
